
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M54.643 0h-45a5.366 5.366 0 00-5.357 5.357v39.249L.2 55.67a3.21 3.21 0 003.845 4.218l15.527-4.175h35.07A5.365 5.365 0 0060 50.357v-45A5.365 5.365 0 0054.643 0zm-37.5 32.143a4.286 4.286 0 110-8.572 4.286 4.286 0 010 8.572zm15 0a4.285 4.285 0 110-8.571 4.285 4.285 0 010 8.57zm15 0a4.285 4.285 0 110-8.571 4.285 4.285 0 010 8.57z","fill":"#FE9500"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h60v60H0z"}})])])])
          )
        }
      }
    